import { createSlice } from "@reduxjs/toolkit";
import { getCourseAssignmentQuestions, getAssignmentQuestions, submitAssignmentAnswer, getModuleScore, bookmarkQuestion } from './thunk';
export const initialState = {
  questions: [],
  moduleScore: {},
  isLoading: false,
  error: {}
};

const Assignment = createSlice({
  name: 'Assignment',
  initialState,
  reducer: {},
  extraReducers: (builder) => {
    builder.addCase(getCourseAssignmentQuestions.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(getCourseAssignmentQuestions.fulfilled, (state, action) => {
      state.questions = action.payload;
      state.isLoading = false;
    });

    builder.addCase(getCourseAssignmentQuestions.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(getAssignmentQuestions.fulfilled, (state, action) => {
      state.questions = action.payload;
    });

    builder.addCase(getAssignmentQuestions.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(submitAssignmentAnswer.fulfilled, (state, action) => {
      const updatedQuestion = action.payload[0] || {};
      state.questions = state.questions.map((item) => item.ID === updatedQuestion.QuestionID ? 
        {...item, 
          CurrentAttempt: updatedQuestion.CurrentAttempt,
          YourScore: updatedQuestion.YourScore,
          PossibleScore: updatedQuestion.PossibleScore,
          SolvedQuestions: updatedQuestion.IsSelectedOptionCorrect ? item.SolvedQuestions + 1 : item.SolvedQuestions,
          SelectedOptionID: updatedQuestion.OptionID ? updatedQuestion.OptionID : item.SelectedOptionID,
          IsSelectedOptionCorrect: updatedQuestion.IsSelectedOptionCorrect,
          IsViewHint: updatedQuestion.IsViewHint,
          IsViewSolution: updatedQuestion.IsViewSolution
        } : item)
    });

    builder.addCase(submitAssignmentAnswer.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(getModuleScore.fulfilled, (state, action) => {
      state.moduleScore = action.payload;
    });

    builder.addCase(getModuleScore.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(bookmarkQuestion.fulfilled, (state, action) => {
      const updatedQuestion = action.payload[0] || {};
      state.questions = state.questions.map((item) => item.ID === updatedQuestion.QuestionID ? 
        {...item, 
          BookmarkID: updatedQuestion.IsDelete ? null : updatedQuestion.BookmarkID
        } : item)
    });
    
    builder.addCase(bookmarkQuestion.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });
  }
});

export default Assignment.reducer;